import { action, makeObservable, observable } from 'mobx';
import queryString from 'query-string';

/** Глобальный store для управления query params */
export class QueryParamsStore {
  /**
   * Поле входящих параметров нужно в следующей ситуации:
   * 1. срабатывает два раза подряд `setParam`
   * 2. после этого только один раз вызывается `update` (в React схлопнулись обновления location)
   *
   * Таким образом в течение вызовов `setParam` накапливаются
   * необходимые обновления, а когда в `update` обновления применились,
   * этот объект перетирается
   * @private
   */
  private _incomingParams: any = {};

  params: any = {};

  constructor() {
    makeObservable(this, {
      params: observable.ref,
      setParam: action,
      update: action.bound,
    });
  }

  update(search: URLSearchParams): void {
    this.params = queryString.parse(search.toString(), {
      arrayFormat: 'separator',
      parseBooleans: true,
      parseNumbers: true,
    });

    this._incomingParams = {};
  }

  getParam = <V = string>(paramName: string): V | undefined => {
    return this.params[paramName] ?? undefined;
  };

  setParam(paramName: string, value: any): void {
    this._incomingParams[paramName] = value ?? undefined;

    const newSearch = queryString.stringify(
      { ...this.params, ...this._incomingParams },
      { arrayFormat: 'separator', skipEmptyString: true },
    );

    if (newSearch !== window.location.search.replace('?', '')) {
      window.history.replaceState({}, '', `${window.location.pathname}${newSearch.length > 0 ? '?' : ''}${newSearch}`);
    }
  }
}
